import { Button, Badge, Layout, Menu, Tooltip } from 'antd';
import { BugOutlined } from '@ant-design/icons';
import { NavigationWrapper } from './style';
import { useNavigate, useLocation } from "react-router-dom";
import { useContext, useEffect, useState, useRef } from "react";
import { Context } from "../../Pages/ContextProvider";
import { UploadImage } from '../../Pages/UploadImage';
import { PatientSearch } from '../../Pages/PatientSearch';
import { PopoverComponent } from '../Common';
import { getFromLocalStorage, removeFromLocalStorage, CONSTANT, Server } from '../../Utils';
import { ReportIssuePanel } from '../Issue/ReportIssuePanel';
import { Services } from '../../__services';

const { Header, Content, Footer } = Layout;

let items = [
    {
        label: 'Data entry',
        key: 'home',
    },
    {
        label: 'Patient Search',
        key: 'search'
    },
    {
        label: 'Upload Images',
        key: 'image'
    }
]

export const LayoutPage = ({ children }) => {
    const [userInfo, setUserInfo] = useState();
    const { state: { page, badge }, updateState } = useContext(Context);
    const [showImageUpload, setShowImageUpload] = useState(false);
    const [showPatientSearch, setShowPatientSearch] = useState(false);
    const [showBadge, setShowBadge] = useState(false);
    const [badgeData, setBadgeData] = useState({ allUnique: { totalCount: 0 } });
    const [showIssuePanel, setShowIssuePanel] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            setBadgeData(badge);
            getUser();
        }

        if (badge) {
            setBadgeData(badge);
        }

        if (isFirstRender.current && userInfo?.user?.person_type_id === CONSTANT.SYSTEMADMIN) {
            isFirstRender.current = false;
            if (!items.find(i => i.key === 'admin')) {
                items = [...items, { label: 'Admin', key: 'admin' }]
            }
        } else if (isFirstRender.current && userInfo?.user?.person_type_id && userInfo?.user?.person_type_id !== CONSTANT.SYSTEMADMIN) {
            isFirstRender.current = false;
        }

    }, [badge, userInfo])

    const getUser = async () => {
        let user = await getFromLocalStorage('user');
        setUserInfo(user);
    }

    const onClickHandler = (type, value) => {
        if (type === 'submitIssue') {
            return submitToGithub(value);
        }
        if (type === 'logout') {
            removeFromLocalStorage('user');
            removeFromLocalStorage('userType');
            updateState('user', null)
            navigate('/')
        } else if (type === 'menu') {
            if (value.key === 'home') {
                updateState('page', 'user');
                navigate('/home', { state: location.state });
            } else if (value.key === 'admin') {
                updateState('page', '/admin');
                navigate('/admin/dashboard', { state: location.state })
            } else if (value.key === 'image') {
                setShowImageUpload(true);
            } else if (value.key === 'search') {
                setShowPatientSearch(true);
            } else if (value.key === 'queries') {
                if (!showBadge) {
                    setShowBadge((prw) => ({
                        ...prw,
                        showBadge: !prw.showBadge,
                    }));
                }
            } else {
                console.log(value);
            }
        } else if (type === 'showPatientSearch') {
            setShowPatientSearch(value);
        } else if (type === 'showImageUpload') {
            setShowImageUpload(false);
        } else if (type === 'openBadge') {
            if (!value) {
                setShowBadge(value);
            }
        } else if (type === 'showIssuePanel') {
            setShowIssuePanel(value);
        }
    }

    const visitSummaryItems = [
        {
            label: <PopoverComponent show={showBadge} data={badgeData} onClick={onClickHandler}>
                <Badge id="audit-badge" count={[CONSTANT.REVIEWER, CONSTANT.SYSTEMADMIN].includes(userInfo?.user?.person_type_id) ? badgeData?.allAnswerd?.length : badgeData?.allCorrection?.length || 0} offset={[10, -11]}
                    style={{ zIndex: 9999999 }}>
                    <div style={{ color: 'rgba(255, 255, 255, 0.65)' }}>Queries</div>
                </Badge></PopoverComponent>, key: 'queries'
        }, ...items
    ]

    const submitToGithub = async (value) => {
        const userName = [userInfo?.user?.person?.first_name, userInfo?.user?.person?.last_name].filter(Boolean).join(' ') || '';
        const email = userInfo?.user?.email || '';
        const userLine = [userName, email].filter(Boolean).join(' - ');
        const createdByLine = userLine ? `Ticket created by ${userLine}` : '';
        const description = [value.description?.trim(), createdByLine].filter(Boolean).join('\n\n');
        const payload = {
            title: value.title,
            description,
            tags: [value.priority, Server.ENV.name],
            repo: value.repo || 'visilant_webapp',
            images: value.attachments
        };
        try {
            const result = await Services.PostGithubTicket(payload);
            if (result?.status !== undefined && result.status !== 200) {
                throw new Error(result?.data?.message || 'Failed to submit issue');
            }
            return true;
        } catch (err) {
            const msg = err?.response?.data?.message || err?.message || 'Failed to submit issue';
            throw new Error(msg);
        }
    };

    return (
        <>
            <Layout style={{ minHeight: "100vh" }}>
                <Header style={{ position: 'sticky', top: 0, zIndex: 1, width: '100%' }}>
                    <NavigationWrapper>
                        <div id="nav-bar" style={{ display: 'flex', alignItems: 'center', gap: '3%' }}>
                            <Menu theme="dark" mode="horizontal"
                                style={{ width: location.pathname.includes('/visitsummary') ? '530px' : '445px' }}
                                items={location.pathname.includes('/visitsummary') && getFromLocalStorage('userType') === 'user' ? visitSummaryItems : items} onClick={(e) => onClickHandler('menu', e)} />
                            <Button type="primary" danger onClick={() => onClickHandler('logout')}>Logout</Button>
                        </div>
                    </NavigationWrapper>
                </Header>
                <Content>
                    <div style={{ padding: page !== '/admin' ? '24px 100px' : '' }}>
                        {children}
                    </div>
                </Content>
                {page !== '/admin' ?
                    <Footer style={{ textAlign: 'center', position: 'sticky', bottom: '0', padding: '10px' }}>Visilant ©2023</Footer>
                    : null}
            </Layout>
            {page !== '/admin' && (
                <Tooltip title="Report an Issue" placement="left">
                    <Button
                        shape="circle"
                        icon={<BugOutlined />}
                        onClick={() => onClickHandler('showIssuePanel', true)}
                        style={{
                            position: 'fixed',
                            bottom: 24,
                            right: 24,
                            zIndex: 1000,
                            width: 48,
                            height: 48,
                            fontSize: 20,
                        }}
                    />
                </Tooltip>
            )}
            {showImageUpload ? <UploadImage onClick={onClickHandler} /> : null}
            {showPatientSearch ? <PatientSearch onClick={onClickHandler} /> : null}
            {showIssuePanel ?
                <ReportIssuePanel
                    open={showIssuePanel}
                    onClose={() => onClickHandler('showIssuePanel', false)}
                    onSubmit={onClickHandler}
                />
                : null}
        </>
    )
}
